import TablaNotificaciones from "./TablaNotificaciones"
const Notificaciones = () => {
    return (
        <div>
            <h4>Historial de Notificaciones</h4>
            <TablaNotificaciones />
        </div>
    )
}
export default Notificaciones